import { createSelector } from 'reselect'
import { AppStateType } from '../reducers'
import { IPublishedGraphic } from '../types/publishedGraphic'

export const selectPublishedGraphic = createSelector(
  [(state: AppStateType) => state.publishedGraphic],
  (publishedGraphic: IPublishedGraphic) => publishedGraphic
)
